import questionOnly from "@/utils/questionOnly";

import { getToken, reLogin, enQues } from "@/utils/common";
import { Toast } from "vant";

export const cacheSubmit = (self, type) => {
  if (self.submitting || !self.staging_able || self.try) return;
  let { version, qid, lists, rec_staging_id, cI, staging_data = {} } = self;
  if (!lists || !lists.length) return;
  let submitData = lists;
  if (type) {
    submitData = [];
    lists.map((item, index) => {
      if (item.has_change) {
        item.oriIndex = index;
        submitData.push(item);
      }
    });
    submitData = translateSubmitList(self, submitData, "cache", "part").optC;
  } else {
    submitData = translateSubmitList(self, submitData, "cache").optC;
  }
  let { t_start } = staging_data;
  let server_now = type ? t_start : localStorage.getItem("start_time_" + qid);
  let param = {
    access_token: getToken(),
    qid,
    t_start: server_now > 0 ? parseInt(server_now) : 0,
    data: submitData,
    ...(type ? {} : { version }),
    type,
    time:
      self.time_limit > 0 ? self.time_limit * 60 - self.timeNum : self.timeNum,
    ...(type ? { rec_staging_id, curr_index: cI } : {}),
    ...self.en ? { en: enQues(self.en) } : {}
  };
  questionOnly.post("/xcx/ques/v1/submit/staging", param).then(res => {
    if (res.sta == 0) {
      if (!type) {
        self.staging_data = {...staging_data, rec_staging_id: res.rec_staging_id}
        self.rec_staging_id = res.rec_staging_id;
      } else {
        lists.map(item => (item.has_change = 0));
        self.lists = lists;
      }
    } else if (res.sta === -500) {
      reLogin();
    } else if (res.sta == -1 && res.errcode == 108) {
      self.handleRepeatSubmit(res);
    } else {
      Toast(res.msg);
    }
  });
};

export const translateSubmitList = (self, lists, cache, type) => {
  // 老方法 || temp = 1/2 传全部其他状态传简易
  let whole = false;
  if (
    !self.staging_switch ||
    self.temp == 2 ||
    self.staging_data.status ||
    !self.staging_data.version_code
  ) {
    whole = true;
  }
  
  let optC = {};
  lists.map((n, j) => {
    if (type) {
      j = n.oriIndex;
    }
    optC[j] = {};
    optC[j]["id"] = n.qqid ? n.qqid : n.id;
    optC[j]["type"] = n.type;
    if(n['score']) {
      optC[j]['score'] = n.score;
    }
    if (whole) {
      optC[j]["options"] = n.options;
      //  if(self.temp == 3) {
      //   optC[j]['show_order'] = n.options;
      //  }
      optC[j]["parsing_imgs"] = n.origin_parsing_imgs
        ? n.origin_parsing_imgs
        : n.parsing_imgs;
      optC[j]["imgs"] = n.origin_imgs ? n.origin_imgs : n.imgs;
      optC[j]["answer"] = n.answer;
      optC[j]["desc"] = n.desc;
      if (n.videos) {
        n.videos.map(item => {
          item.thumb = item.origin_thumb ? item.origin_thumb : item.thumb;
          delete item.origin_thumb;
        });
        optC[j]["videos"] = n.videos;
      }
      if(n.parsing_items) {
        optC[j]['parsing_items'] = n.parsing_items;
      }
    } else {
      if (n.options && n.options.length) {
        if (n.type <= 2) {
          let simpleOpt = [];
          n.options.map(item => {
            simpleOpt.push({
              id: item.id,
              check: item.check,
              ...item.hasOwnProperty('blank_input') ? {
                blank_input: item.blank_input
              } : {}
            });
          });
          optC[j]["options"] = simpleOpt;
        } else {
          optC[j]["options"] = n.options;
        }
      }
      // if(self.temp == 3) {
      //   optC[j]['show_order'] = optC[j]['options'];
      // }
    }
    if (cache) {
      optC[j]["your_answer"] = n.your_answer;
      optC[j]["hasAnswer"] = n.hasAnswer;
      if (self.show_answer_type || self.single_time_limit > 0) {
        optC[j]["showAnswer"] = n.showAnswer;
      }
      if (self.temp === 3) {
        optC[j]["required"] = n.required;
      }
      if (n.type === 4) {
        optC[j]["enable_img"] = n.enable_img;
      }
      if (self.single_time_limit > 0) {
        optC[j]['t_start'] = n.t_start;
      }
    }
    if (n.type === 4) {
      // 简答题
      optC[j]["img"] = n.img;
      optC[j]["opt"] = [];
      optC[j]["opt"].push(n.disscussion_input || "");
      if (cache) {
        optC[j]["disscussion_input"] = n.disscussion_input;
      }
    }
    if (n.type === 3) {
      optC[j]['order_answer'] = n.order_answer || 0;
    }
  });
  return { optC };
};

export const getDetail = self => {
  return new Promise(reslove => {
    let server_now = localStorage.getItem("start_time_" + self.qid);
    let param = {
      access_token: getToken(),
      qid: self.qid,
      t_start: server_now > 0 ? parseInt(server_now) : 0,
      ...self.try ? { source: 1} : {}
    };
    questionOnly.get("/xcx/ques/v3/detail", param).then(res => {
      if (res.sta == 0) {
        reslove(res.data)
      } else if (res.sta === -500) {
        reLogin();
      } else {
        Toast(res.msg);
      }
    });
  });
};



// WEBPACK FOOTER //
// ./src/pages/normal/fn.js